import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com']

@Component({
  selector: 'app-firebase',
  templateUrl: './firebase.component.html',
  styleUrls: ['./firebase.component.css']
})
export class FirebaseComponent extends BaseComponent implements OnInit {

  @ViewChild('canvas', { static: true })
  canvas: ElementRef<HTMLCanvasElement>
  ctx: any

  database = inject(Database);
  worldsRef: any;
  worlds: any; //downloaded worlds from database
  worldskeys: any = [] //keys of properties of worlds {id:0,name: "demo"}
  worldkey = 0 //index for select
  world: any = null //selected world
  components: any = []
  component: any = {} //component to edit
  showModal = false
  newWorldName = ""
  skybox: any = {}
  walls: any = {}
  ground: any = {}
  scenarios: any = []
  sortArray: any = []
  showPlayers = false
  isAuthenticatedWithFirebase = false

  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async signOut() {
    try {
      await getAuth().signOut()
      this.isAuthenticatedWithFirebase = false
    } catch (error) {
      console.log(error)
    }
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }

  async getData() {
    this.loader.show()

    // this.worldsRef = await get(child(ref(this.database), `worlds`));
    // this.worlds = this.worldsRef.val()
    // this.worldskeys = this.getKeys(this.worlds)

    this.worldsRef = ref(this.database, 'worlds');
    const snapshot = await get(this.worldsRef);
    if (snapshot.exists()) {
      this.worlds = snapshot.val();
      this.worldskeys = this.getKeys(this.worlds)
    }

    const scenarios2 = ref(this.database, 'scenarios');
    const snapshot2 = await get(scenarios2);
    if (snapshot2.exists()) {
      this.scenarios = this.collectionToArray(snapshot2.val());
    }


    this.loader.hide()
  }

  //convert collection to array of objects
  collectionToArray(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key, ...obj[key] })
    }
    return keys
  }

  // get the number of properties of an object
  getNumberOfKeys(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key })
    }
    return keys.length
  }

  //remove proterty players from scenario in firebase

  async removePlayerFromScenario(scenario: any) {
    const scen = scenario.name
    delete scenario.players
    delete scenario.id
    delete scenario.name
    await set(ref(this.database, 'scenarios/' + scen), scenario);
    await this.getData()
  }

  selectWorld() {
    const worldname = this.worldskeys[this.worldkey].name
    this.world = this.worlds[worldname]
    this.components = this.world.components
    if (this.components != null) {
      this.components.forEach((component: any) => {
        if (component['rotX'] == null) component['rotX'] = 0
        if (component['rotY'] == null) component['rotY'] = 0
        if (component['rotZ'] == null) component['rotZ'] = 0
        if (component['checkCollisions'] == null) component['checkCollisions'] = true

      })
    }

    this.walls = this.world.walls
    this.ground = this.world.ground
    this.skybox = this.world.skybox

    this.plotObjects();
  }

  async updateWorld() {
    //this.worlds.demo.components[0].posY=3
    this.showModal = false
    await set(this.worldsRef, this.worlds);
    this.plotObjects()
  }

  editComponent(c: any) {
    this.component = c
    this.showModal = true
  }

  nameHasChanged() {
    this.component.file = this.component.name + ".glb"
  }

  addComponent() {
    this.component = {
      name: "newName",
      file: "newFile",
      posX: 0,
      posY: 0,
      posZ: 0,
      rotX: 0,
      rotY: 0,
      rotZ: 0,
      scale: 1,
      checkCollisions: true
    }
    if (this.components == null) {
      this.components = []
      this.world.components = this.components
    }
    this.components.push(this.component)
    this.showModal = true
  }

  async deleteComponent(c: any) {
    let index = -1
    this.components.forEach((obj: any, ind: number) => {
      if (obj != null) {
        if (c.name == obj.name) index = ind
      }
    })
    //const index = this.components.findIndex((obj: any) => obj.name === c.name);

    // Remove the object if it's found
    if (index !== -1) {
      this.components.splice(index, 1);
      await this.updateWorld()
    }
  }

  mapToCanvasCoord(x: number, y: number, width: number, height: number) {
    const canvas = this.canvas.nativeElement;
    const mappedX = (x + width / 2) * (canvas.width / width);
    const mappedY = (height / 2 - y) * (canvas.height / height);
    return { x: mappedX, y: mappedY };
  }

  plotObjects() {
    // Clear the canvas
    this.ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);

    // Loop through your objects to plot them
    if (this.components != null) {
      this.components.forEach((obj: any) => {
        const { x, y } = this.mapToCanvasCoord(obj.posX, obj.posZ, 55, 55);

        // Draw a circle at the object's position
        this.ctx.beginPath();
        this.ctx.arc(x, y, 5, 0, Math.PI * 2);
        this.ctx.fillStyle = "green"
        this.ctx.fill();
        this.ctx.fillStyle = "blue"
        // Add the object's name next to the circle
        this.ctx.fillText(obj.name, x + 10, y - 2 + Math.random() * 20);
      });

    }
  }

  async addWorld() {
    let dupObj = this.worldskeys.find((k: any) => k.name == this.newWorldName)
    if (dupObj == null) {
      this.selectWorld()
      const copiedObject = JSON.parse(JSON.stringify(this.world))
      this.worlds[this.newWorldName] = copiedObject
      await this.updateWorld()
    } else {
      this.alert.danger("Name of World must be unique")
    }
  }

  deleteClone(clone: any) {

  }

  deleteSensor(sensor: any) {

  }

  addClone() {
    if (this.component['clones'] == null) this.component['clones'] = []
    const clone = {
      posX: 0,
      posY: 0,
      posZ: 0,
      rotX: 0,
      rotY: 0,
      rotZ: 0
    }
    this.component['clones'].push(clone)
  }

  // equivalent to addClone create addSensor with the fields name, units,min_distance, max_distance, max_value
  addSensor() {
    if (this.component['sensors'] == null) this.component['sensors'] = []
    const sensor = {
      name: "newSensor",
      units: "m",
      min_distance: 0,
      max_distance: 10,
      max_value: 100
    }
    this.component['sensors'].push(sensor)
  }

  removePlayer(scenario: any) {

  }
}
